import {ECCurveFp, ECPointFp} from './ec';
import {getSECCurveByName} from './sec';
import {SecureRandom} from './rng';
import {BigInteger} from './jsbn2';

let CryptoJS = require("crypto-js");

let _crypto = {};

function init() {
    _crypto.c = getSECCurveByName('secp256r1');
    _crypto.priv = do_priv();
    _crypto.pub = do_pub(_crypto.priv);
}

function do_priv() {
    let rng = new SecureRandom();
    let n = new BigInteger(_crypto.c.getN().toString());
    let n1 = n.subtract(BigInteger.ONE);
    let r = new BigInteger(n.bitLength(), rng);

    return r.mod(n1).add(BigInteger.ONE).toString();
}

function do_pub(priv) {
    let curve = get_curve();
    let G = get_G(curve);
    let a = new BigInteger(priv);
    let P = G.multiply(a);
    return {x: P.getX().toBigInteger().toString(), y: P.getY().toBigInteger().toString()};
}

function get_curve() {
    return new ECCurveFp(
        new BigInteger(_crypto.c.getCurve().getQ().toString()),
        new BigInteger(_crypto.c.getCurve().getA().toBigInteger().toString()),
        new BigInteger(_crypto.c.getCurve().getB().toBigInteger().toString())
    );
}

function get_G(curve) {
    return new ECPointFp(
        curve,
        curve.fromBigInteger(new BigInteger(_crypto.c.getG().getX().toBigInteger().toString())),
        curve.fromBigInteger(new BigInteger(_crypto.c.getG().getY().toBigInteger().toString()))
    );
}

function getPub() {
    return _crypto.pub;
}

function deriveKey(pub) {
    let curve = get_curve();
    let P = new ECPointFp(curve, curve.fromBigInteger(new BigInteger(pub.x)), curve.fromBigInteger(new BigInteger(pub.y)));

    let a = new BigInteger(_crypto.priv);
    let S = P.multiply(a);
    _crypto.key = {x: S.getX().toBigInteger().toString(), y: S.getY().toBigInteger().toString()};
}

/**
 * @param {any} data
 */
function encrypt(data) {
    return CryptoJS.AES.encrypt(data, _crypto.key.x).toString();
}

function decrypt(data) {
    let bytes = CryptoJS.AES.decrypt(data, _crypto.key.x);
    return bytes.toString(CryptoJS.enc.Utf8);
}

const ecdh = {init, getPub, deriveKey, encrypt, decrypt};
export default ecdh;
